import React from "react";
import { useWatch } from "react-hook-form";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import { C_PERTENECE } from "../models/acoprivi.const";

const useAcoprovi = () => {
  const type = useWatch({
    name: CPropertyValidationDocumentKeys.type_association_acoprovi,
    defaultValue: []
  });

  const value = HGetValueFromArray(type, "value");

  return {
    isAcoprovi: value == C_PERTENECE.Acoprovi.value,
    isAprocovici: value == C_PERTENECE.Aprocovici.value,
    not: value == C_PERTENECE.Ninguna.value
  };
};

export default useAcoprovi;
